import { Tooltip } from '@mui/material';
import React, { FC, ReactElement } from 'react';

type HighLightProps = {
    data: string;
    originalData: string;
};

export function withHighLight<T>(Component: FC<T>): FC<T & HighLightProps> {
    const ComponentWithHighlight = ({ originalData, ...restProps }: T & HighLightProps): ReactElement => {
        const isChanged = restProps.data !== originalData;
        const strike = !restProps.data && originalData ? { textDecoration: 'line-through' } : {};
        const style = isChanged
            ? {
                  textDecoration: 'underline',
                  textDecorationColor: '#f3a13d',
                  textDecorationThickness: '2px',
                  ...strike,
              }
            : { ...strike };
        // TODO: Translate tooltips...
        if (isChanged) {
            return (
                <Component style={style} {...(restProps as T)}>
                    {originalData ? (
                        <Tooltip title={`Ursprungligt värde: ${originalData}`}>
                            <span>{restProps.data}</span>
                        </Tooltip>
                    ) : (
                        <Tooltip title="Tillagd, ej del av ursprunglig order.">
                            <span>{restProps.data}</span>
                        </Tooltip>
                    )}
                </Component>
            );
        }
        return <Component {...(restProps as T)}>{restProps.data}</Component>;
    };
    ComponentWithHighlight.displayName = `ComponentWithHighlight(${Component.displayName || Component.name})`;
    return ComponentWithHighlight;
}
